module.exports = function() {
  return new Worker(__webpack_public_path__ + "6baed70f09d4eb0d05a5.worker.js");
};